import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { MuteLogo } from '../components/ui/MuteLogo';
import { useAppDispatch } from '../store/hooks';
import * as usersApi from '../api/users';
import { setUser } from '../store/slices/authSlice';
const SLIDES = [
    {
        headline: 'Включи\nреальность.',
        headlineSize: 48,
        text: (_jsxs(_Fragment, { children: [_jsx("strong", { children: "Mute" }), " \u2014 \u043C\u0435\u0441\u0442\u043E \u0432\u0441\u0442\u0440\u0435\u0447. \u0421\u043F\u043E\u0441\u043E\u0431 \u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F \u0440\u044F\u0434\u043E\u043C \u0441 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u043C \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u043E\u043C."] })),
    },
    {
        headline: 'Не пиши.\nЗови.',
        headlineSize: 46,
        text: (_jsxs(_Fragment, { children: ["\u0418\u0437\u0443\u0447\u0430\u0439 \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0438 \u043B\u044E\u0434\u0435\u0439. \u041D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u2014 ", _jsx("strong", { children: "\u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0430\u0439 \u043D\u0430 \u0432\u0441\u0442\u0440\u0435\u0447\u0443" }), " \u043F\u0440\u044F\u043C\u043E \u0441\u0435\u0439\u0447\u0430\u0441."] })),
    },
    {
        headline: 'Зажги\nмаяк.',
        headlineSize: 46,
        text: (_jsxs(_Fragment, { children: ["\u0421\u043E\u0437\u0434\u0430\u0439 \u0441\u043E\u0431\u044B\u0442\u0438\u0435 \u2014 \u043A\u043E\u0444\u0435, \u0439\u043E\u0433\u0430, \u0443\u0436\u0438\u043D. \u041A\u0442\u043E-\u0442\u043E \u043E\u0442\u043A\u043B\u0438\u043A\u043D\u0435\u0442\u0441\u044F.", ' ', _jsx("strong", { children: "\u0427\u0430\u0442 \u043D\u0430 24 \u0447\u0430\u0441\u0430 \u2192 \u0432\u0441\u0442\u0440\u0435\u0447\u0430." })] })),
    },
];
export function OnboardingIntroPage() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [current, setCurrent] = useState(0);
    const [loading, setLoading] = useState(false);
    const touchStart = useRef(0);
    const isLast = current === SLIDES.length - 1;
    const handleNext = useCallback(async () => {
        if (!isLast) {
            setCurrent((c) => c + 1);
            return;
        }
        // Last screen — set city to Kaş (id=2) and go to profile onboarding
        setLoading(true);
        try {
            const updatedUser = await usersApi.updateProfile({ cityId: 2 });
            dispatch(setUser(updatedUser));
            localStorage.setItem('mute_intro_seen', '1');
            navigate('/onboarding', { replace: true });
        }
        catch {
            // If city update fails, still proceed
            localStorage.setItem('mute_intro_seen', '1');
            navigate('/onboarding', { replace: true });
        }
    }, [isLast, navigate, dispatch]);
    const handleTouchStart = (e) => {
        touchStart.current = e.touches[0].clientX;
    };
    const handleTouchEnd = (e) => {
        const diff = touchStart.current - e.changedTouches[0].clientX;
        if (diff > 50 && current < SLIDES.length - 1) {
            setCurrent((c) => c + 1);
        }
        else if (diff < -50 && current > 0) {
            setCurrent((c) => c - 1);
        }
    };
    const slide = SLIDES[current];
    return (_jsxs("div", { className: "absolute inset-0 flex flex-col overflow-hidden", style: { background: '#0A0A0A' }, onTouchStart: handleTouchStart, onTouchEnd: handleTouchEnd, children: [_jsx("div", { className: "flex-shrink-0 flex justify-center", style: { paddingTop: 52 }, children: _jsx(MuteLogo, { size: 56 }) }), _jsxs("div", { className: "flex-1 flex flex-col items-center justify-center px-7", style: { marginTop: -12 }, children: [_jsx("h2", { className: "text-center leading-none", style: {
                            fontFamily: "'Outfit', sans-serif",
                            fontWeight: 700,
                            fontSize: slide.headlineSize,
                            lineHeight: 1.08,
                            background: 'linear-gradient(135deg, #fff 30%, #EC4899)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text',
                            whiteSpace: 'pre-line',
                        }, children: slide.headline }), _jsx("p", { className: "text-center", style: {
                            fontSize: 15,
                            color: 'rgba(255,255,255,.4)',
                            lineHeight: 1.65,
                            marginTop: 16,
                        }, children: slide.text })] }), _jsxs("div", { className: "flex-shrink-0", style: { padding: '0 24px 40px' }, children: [_jsx("div", { className: "flex gap-1.5 justify-center", style: { marginBottom: 16 }, children: SLIDES.map((_, i) => (_jsx("div", { style: {
                                width: i === current ? 24 : 8,
                                height: 8,
                                borderRadius: i === current ? 4 : '50%',
                                background: i === current ? '#EC4899' : 'rgba(255,255,255,.15)',
                                transition: 'all .3s ease',
                            } }, i))) }), _jsx("button", { onClick: handleNext, disabled: loading, style: {
                            display: 'block',
                            width: '100%',
                            padding: 16,
                            borderRadius: 14,
                            border: 'none',
                            background: '#EC4899',
                            color: '#fff',
                            fontFamily: "'Space Grotesk', sans-serif",
                            fontSize: 16,
                            fontWeight: 600,
                            cursor: loading ? 'default' : 'pointer',
                            opacity: loading ? 0.6 : 1,
                            letterSpacing: 0.5,
                        }, children: isLast ? 'Начать' : 'Далее' })] })] }));
}
